import React from 'react';
import _ from 'lodash';

import {
  FeatureName,
  SalesChannelName,
  StoreTypeName,
  useStoreSelectFieldQuery
} from 'generated/graphql';



export interface IStore {
  id: string;
  displayName: string;
}

export interface IData {
  objects: IStore[];
}

export function useQuery({
  salesChannel, types, featuresEnabled
}: {
  featuresEnabled?: FeatureName[];
  salesChannel?: SalesChannelName;
  types?: StoreTypeName[];
} = {}) {
  const queryTuple = useStoreSelectFieldQuery({
    variables: {
      featuresEnabled,
      salesChannel,
      types
    }
  });

  const wrappedTuple = React.useMemo(() => {
    const data: IData = {
      objects: _.map(queryTuple.data?.stores.nodes ?? [], (node): IStore => ({
        id: node.id,
        displayName: node.name
      }))
    };

    return {
      loading: queryTuple.loading,
      data,
      refetch: async () => {
        queryTuple.refetch({});
      }
    };
  }, [queryTuple]);

  return wrappedTuple;
}
